<script>
  import { factoryStore } from "../store/factories";
  import { link, push } from "svelte-spa-router";

  import { calculatorStore } from "../store/calculators.js";
  import WizardCalculation from "./WizardCalculation.svelte";
  import WizardSectionSelector from "./WizardSectionSelector.svelte";
  import WizardInputSection from "./WizardInputSection.svelte";
  import WizardSummarySection from "./WizardSummarySection.svelte";
  import { langTextStore } from "../store/langtexts.js";
  import WizardSuperHelpSection from "./WizardSuperHelpSection.svelte";
  import { getContext } from "svelte";
  import LangSelectorRestricted from "../SharedComponents/LangSelectorRestricted.svelte";
  import { tick } from "svelte";
  import { fade } from "svelte/transition";
  import { inputVariableStore } from "../store/inputVariables";
  import ScenarioTool from "./ScenarioTool.svelte";
  import * as util from "../js/util.js";

  import BreakDownSummary from "./BreakDownSummary.svelte";
  import MajorUpgrade from "./MajorUpgrade.svelte";
  import Pluscirkel from "../Vectors/pluscirkel.svelte";
  import Wagedistribution from "./WageDistribution.svelte";
  import ProductListForFactory from "./ProductListForFactory.svelte";
  import Confirm from "../SharedComponents/Confirm.svelte";
  import Prompt from "../SharedComponents/Prompt.svelte";

  import IconRecycle from "../Vectors/recycle.svelte";
  import IconCloud from "../Vectors/cloud.svelte";
  import Logo from "../Vectors/logotransparent.svelte";
  import { outputVariableStore } from "../store/outputVariables";

  const { snackbar } = getContext("app");
  const { open } = getContext("modal");

  export let params = {};
  $: isProductMode =
    params.productId && params.productId.length > 0 ? true : false;
  $: showLangChooserIfNeeded(
    $langTextStore.langName,
    $calculatorStore.availableLangs
  );
  let activeSection = window.location.href.includes("activesection")
    ? "productlist"
    : params.productId && params.productId.length > 0
    ? "product"
    : "settings";

  $: save(activeSection);
  function showLangChooserIfNeeded(langName, availableLangs) {
    if (!availableLangs || availableLangs.length == 0) {
      return;
    }
    if (availableLangs.find((al) => al.langName == langName) == null) {
      open(
        LangSelectorRestricted,
        {
          showChoice: true,
          langs: availableLangs,
          warningText: $langTextStore.getText(
            "general-labels-selected-lang-not-available-for-calculator"
          ),
        },
        { closeButton: false }
      );
    }
  }

  inputVariableStore.clear();
  outputVariableStore.clear();
  let currentSubSectionNameKey = null;

  let doCalculations; // filled by wizardCalculation component
  $: maybeSaveToCloud(activeSection);
  function maybeSaveToCloud(s) {
    if (s == "productlist") {
      saveToCloud();
    }
  }

  $: savestatus = $inputVariableStore.saveStatus;
  let timersaved = null;
  var timersaving = null;
  async function busySaving() {
    clearTimeout(timersaving);
    clearTimeout(timersaved);
    inputVariableStore.setSaveStatus("saving");
  }
  async function showSaved() {
    clearTimeout(timersaving);
    timersaving = window.setTimeout(() => {
      inputVariableStore.setSaveStatus("saved");
      timersaved = window.setTimeout(() => {
        inputVariableStore.setSaveStatus("");
      }, 2000);
    }, 1000);
  }
  var saveDebounceTimer = null;
  let firstTime = true;
  async function save() {
    if (firstTime) {
      firstTime = false;
      return;
    }
    inputVariableStore.setSaveStatus("dirty");

    await tick();
    clearTimeout(saveDebounceTimer);
    saveDebounceTimer = setTimeout(() => {
      saveDebounced();
    }, 3000);
  }
  async function saveDebounced() {
    console.log("saving", $inputVariableStore);
    if (!$factoryStore.currentCalculator.variables) {
      return;
    }
    busySaving();
    var settingsToSave = $factoryStore.currentCalculator;

    for (var theVar in $inputVariableStore) {
      if (
        theVar == "variables" ||
        theVar == "scenarioConfiguration" ||
        theVar == "excelSheetNames"
      ) {
        continue;
      }

      var theRealVar = settingsToSave.variables.find(
        (v) => v.varNameKey == theVar
      );
      if (theRealVar != null) {
        theRealVar.value = $inputVariableStore[theVar];
      } else {
        settingsToSave[theVar] = $inputVariableStore[theVar]; //all the scenario shit...
      }
    }
    settingsToSave.alternateCurrencyRate =
      $inputVariableStore.alternateCurrencyRate;
    settingsToSave.scenarioConfiguration =
      $inputVariableStore.scenarioConfiguration;

    await factoryStore.saveFactory($factoryStore.currentFactory);
    await factoryStore.saveFactoryOrProductSettings(settingsToSave);
    inputVariableStore.setSaveStatus("savedlocal");
  }
  async function saveToCloud(force = false) {
    if ($factoryStore.onlinemode == "offline") return;
    //if (workOffline && !force) return;
    inputVariableStore.setSaveStatus("savingtocloud");
    try {
      await factoryStore.syncall();
      showSaved();
    } catch (s) {
      snackbar("error", "could not sync to cloud :" + s);
    }
  }

  async function cancel() {
    await saveToCloud();
    // snackbar("info", langTextStore.getText("general-all-saved"));
    window.setTimeout(() => {
      hideCalc = true;
      if (fromProductId != null) {
        push("#/calculator/product/" + fromProductId);
        return;
      }
      if (isProductMode) push("#/dashboard/products");
      else push("#/dashboard/factories");
    }, 340);
  }
  $: getInputSections(factoryorProductSettings);
  let calculatorInputSections = [];
  function getInputSections() {
    calculatorInputSections =
      factoryorProductSettings.subSections &&
      factoryorProductSettings.subSections.length > 0 &&
      factoryorProductSettings.subSections.filter((ss) => {
        return ss.isFactorySection != isProductMode && !ss.isSummarySection;
      });
  }

  function previous() {
    var newIndex = getSubSectionIndex(currentSubSectionNameKey) - 1;
    currentSubSectionNameKey =
      calculatorInputSections[newIndex].subSectionNameKey;
  }

  function next() {
    var newIndex = getSubSectionIndex(currentSubSectionNameKey) + 1;
    currentSubSectionNameKey =
      calculatorInputSections[newIndex].subSectionNameKey;
  }
  function getSubSectionIndex(subSectionNameKey) {
    var foundItem = calculatorInputSections.find(
      (s) => s.subSectionNameKey == subSectionNameKey
    );
    var index = calculatorInputSections.indexOf(foundItem);
    return index;
  }

  $: isLocked = $factoryStore.currentCalculator.isLocked;
  let hideCalc = false;
  let bShowWageDistribution = false;
  let factoryorProductSettings = { subSections: [] };
  let factory = {};
  $: getFactorySettingsOrProduct(params);
  let calculator = {};

  async function getFactorySettingsOrProduct(params) {
    if (
      (!params.factorySettingsId || params.factorySettingsId.length == 0) &&
      (!params.productId || params.productId.length == 0)
    )
      return;

    if (params.factorySettingsId && params.factorySettingsId.length > 0) {
      factoryorProductSettings = await factoryStore.getFactorySettings(
        params.factorySettingsId
      );
    }
    if (params.productId && params.productId.length > 0) {
      factoryorProductSettings = await factoryStore.getProduct(
        params.productId
      );
    }

    factory = await factoryStore.getFactory(factoryorProductSettings.factoryId);
    if ($factoryStore.onlinemode != "offline") {
      if (
        true ||
        !factoryorProductSettings.variables ||
        factoryorProductSettings.variables.length == 0
      ) {
        calculator = await calculatorStore.getCalculator(
          factoryorProductSettings.countryVersionId
        );
        factoryorProductSettings = {
          ...calculator,
          ...factoryorProductSettings,
        };
        factoryStore.saveFactoryOrProductSettings(factoryorProductSettings);

        //Todo check calculator version update!
      }
    }
    calculatorStore.update((n) => factoryorProductSettings);
    calculatorStore.update((n) =>
      Object.assign(n, {
        availableLangs: factoryorProductSettings.availableLangs,
      })
    );

    inputVariableStore.update((n) =>
      Object.assign(n, {
        scenarioConfiguration: factoryorProductSettings.scenarioConfiguration,
      })
    );
    await tick();
    currentSubSectionNameKey = "basic-settings";
    doCalculations($inputVariableStore);
    if(factoryorProductSettings.scenarioConfiguration==null){
      factoryorProductSettings.scenarioConfiguration =  {
        "scenarios": [
            "target-wage",
            "alternate"
        ],
        "scenarioVars": [
            "Wage"
        ],
        "scenarioVarValues": {
            "target-wage": {
                "Wage": factoryorProductSettings.targetWage || 1
            },
            "alternate": {}
        },
        "calculatedScenarios": []
     }

     await factoryStore.saveFactoryOrProductSettings(factoryorProductSettings);
     window.location.reload();
    return
   }
    if (!isProductMode) {
      doUpgrades(); //dont wait for it
    }
    if (isProductMode) {
      checkFactorySettingVersion();
    }
  }

  async function doUpgrades() {
    await doMinorUpgrade();
    await doMajorUpgrade();
    await tick();
    if (hasPendingMajorUpgrade) {
      initiateMajorUpgrade();
    }
  }
  async function doMinorUpgrade() {

   
    if ($factoryStore.onlinemode == "offline") {
      return;
    }

    //get new calculator version if found
    var url =
      "api/country/getMinorCalculatorVersionUpgrade?countryVersionId=" +
      factoryorProductSettings.countryVersionId;
    if (window.location.href.includes("test=true")) {
      url += "&istest=true";
    }
    var newMinorCalculatorVersionUpgrade = await util.fetchJson(url);
    if (
      newMinorCalculatorVersionUpgrade != null &&
      newMinorCalculatorVersionUpgrade.variables != null
    ) {
      var updateText =
        "applied minor update from version " +
        factoryorProductSettings.calculatorVersionNumber +
        " to  " +
        newMinorCalculatorVersionUpgrade.calculatorVersionNumber;
      await doUpgrade(newMinorCalculatorVersionUpgrade);
      snackbar("info", updateText);
    }
  }

  async function doUpgrade(upgradeVersion) {
    clearTimeout(saveDebounceTimer);
    var inputSections = factoryorProductSettings.subSections.filter((s) => {
      return !s.isSummarySection;
    });
    var inputVars = [];
    for (var inputSection in inputSections) {
      for (var thevar in inputSections[inputSection].variables) {
        var theActualVar = factoryorProductSettings.variables.find(
          (v) =>
            v.varNameKey ==
            inputSections[inputSection].variables[thevar].nameKey
        );
        if (!theActualVar.isFunction && !theActualVar.readonly) {
          inputVars.push(theActualVar);
        }
      }
    }

    var alternateCurrencyRate = factoryorProductSettings.alternateCurrencyRate;
    var alternateCurrencyId = factoryorProductSettings.alternateCurrencyId;

    factoryorProductSettings = Object.assign(
      factoryorProductSettings,
      upgradeVersion,
      { alternateCurrencyId, alternateCurrencyRate }
    );
    for (var thevar in inputVars) {
      var theUpdateVar = factoryorProductSettings.variables.find(
        (v) => v.varNameKey == inputVars[thevar].varNameKey
      );
      {
        theUpdateVar.value = inputVars[thevar].value;
      }
    }
    factoryorProductSettings.excelSheetNames = upgradeVersion.excelSheetNames;
    factoryorProductSettings.countryVersionId = upgradeVersion.countryVersionId;
    factoryorProductSettings.calculatorVersionNumber =
      upgradeVersion.calculatorVersionNumber;
    factoryStore.update((n) => ({
      ...n,
      currentCalculator: {
        ...n.currentCalculator,
        countryVersionId: upgradeVersion.countryVersionId,
        currencyId: upgradeVersion.currencyId,
        excelSheetNames: upgradeVersion.excelSheetNames,
        calculatorVersionNumber: upgradeVersion.calculatorVersionNumber,
      },
    }));

    console.log($factoryStore.currentCalculator);
    await factoryStore.saveFactoryOrProductSettings(factoryorProductSettings);
    calculatorStore.update((n) => factoryorProductSettings);
    calculatorStore.update((n) =>
      Object.assign(n, {
        availableLangs: factoryorProductSettings.availableLangs,
      })
    );
    console.log($inputVariableStore);

    inputVariableStore.update((n) =>
      Object.assign(n, {
        scenarioConfiguration: factoryorProductSettings.scenarioConfiguration,
      })
    );
    doCalculations($inputVariableStore);
    await factoryStore.saveFactoryOrProductSettings(factoryorProductSettings);
    currentSubSectionNameKey = "basic-settings";
  }

  $: setWageDistributionVars(factoryorProductSettings);
  function setWageDistributionVars(settings) {
    if (!settings.variables) return;
    const levels = [
      "lessthan1",
      "between1and2",
      "between2and3",
      "between3and4",
      "morethan4",
    ];

    const grades = util.getWageGradesForCountry(settings)
    for (var level in levels) {
      for (var grade in grades) {
        var theActualVar = factoryorProductSettings.variables.find(
          (v) =>
            v.varNameKey.toLowerCase() ==
            (grades[grade] + levels[level]).toLowerCase()
        );
        if (theActualVar != null) {
          //ad to input vars?
        }
      }
    }
  }

  var newMajorCalculatorVersionUpgrade = {};

  let hasPendingFactorySettingUpgrade = false;
  $: hasPendingMajorUpgrade =
    newMajorCalculatorVersionUpgrade != null &&
    newMajorCalculatorVersionUpgrade.variables != undefined &&
    newMajorCalculatorVersionUpgrade.variables != null &&
    newMajorCalculatorVersionUpgrade.variables.length > 0;
  async function doMajorUpgrade() {
    if ($factoryStore.onlinemode == "offline") return;
    //get new calculator version if found
    var url =
      "api/country/getMajorCalculatorVersionUpgrade?countryVersionId=" +
      factoryorProductSettings.countryVersionId;
    if (window.location.href.includes("test=true")) {
      url += "&istest=true";
    }
    newMajorCalculatorVersionUpgrade = await util.fetchJson(url);
  }

  async function checkFactorySettingVersion() {
    if (factoryorProductSettings.isLocked) {
      return;
    }
    var factorySettingChangeDate =
      await factoryStore.getFactorySettingsChangeDate(
        factoryorProductSettings.factorySettingId
      );
    if (
      factorySettingChangeDate !=
      factoryorProductSettings.factorySettingChangeDate
    ) {
      hasPendingFactorySettingUpgrade = true;
    } else {
      hasPendingFactorySettingUpgrade = false;
    }
    if (hasPendingFactorySettingUpgrade) {
      await factoryStore.setFactorySettingToCurrentProduct(
        factoryorProductSettings.factorySettingId
      );
      hasPendingFactorySettingUpgrade = false;
      snackbar("info", "factory settings applied");
    }
  }
  async function initiateFactorySettingUpgrade() {
    alert("old function");
    //     open(Confirm, {
    //         confirmAction: async () => {
    //             await factoryStore.setFactorySettingToCurrentProduct(
    //                 factoryorProductSettings.factorySettingId
    //             );
    //             hasPendingFactorySettingUpgrade = false;
    //             snackbar("info", "factory settings applied");
    //         },
    //         actionButtonTextOverrideLangKey: "general-label-update-now",
    //         cancelButtonTextOverrideLangKey: "general-label-cancel",
    //         titleLangKey: "general-update-from-changed-factory-setting-title",
    //         contentLangKey: "general-update-from-changed-factory-content",
    //     });
  }
  function initiateMajorUpgrade() {
    open(MajorUpgrade, {
      newVersion: newMajorCalculatorVersionUpgrade,
      oldVersion: factoryorProductSettings,
      doUpdate: () => {
        doUpgrade(newMajorCalculatorVersionUpgrade);
        snackbar("info", "version updated");
        newMajorCalculatorVersionUpgrade = {};
      },
    });
  }
  $: showSuperHelp = $factoryStore.showSuperHelp;
  var internalShowSummary = true;
  var internalshowSuperHelp = false;
  $: toggleSuperHelpDisplay(showSuperHelp);

  function toggleSuperHelpDisplay(bShowSuperHelp) {
    if (bShowSuperHelp) {
      internalShowSummary = false;
      window.setTimeout(() => {
        internalshowSuperHelp = true;
      }, 400);
    } else {
      internalshowSuperHelp = false;
      window.setTimeout(() => {
        internalShowSummary = true;
      }, 400);
    }
  }

  $: summaryOrHelpBackgroundClass = showSuperHelp ? "bg-primary" : "bg-gray-1";

  function showWageDistribution() {
    hideCalc = true;
    bShowWageDistribution = true;
  }

  function hideWageDistribution() {
    var prevSection = currentSubSectionNameKey;
    window.setTimeout(() => {
      currentSubSectionNameKey = prevSection;
    }, 100);
    hideCalc = false;
    bShowWageDistribution = false;
  }
  function copyProduct() {
    open(Prompt, {
      confirmAction: async (name) => {
        var newId = await factoryStore.copyProduct(params.productId, name);
        snackbar("info", "product copied");
        push("/calculator/product/" + newId);
      },
      inputVal:
        factoryorProductSettings.name +
        " (" +
        $langTextStore.getText("general-label-copy") +
        " )",
      actionButtonTextOverrideLangKey: "general-label-copy",
      cancelButtonTextOverrideLangKey: "general-label-cancel",
      titleLangKey: "general-copy-product-name",
      contentLangKey: "general-enter-name-for-new-product",
    });
  }
  var x = $langTextStore.getText("general-label-copy");
  function copyFactory() {
    open(Prompt, {
      confirmAction: async (name) => {
        var newId = await factoryStore.copyFactorySettings(
          params.factorySettingsId,
          name
        );
        snackbar("info", "factory settings copied");
        push("/calculator/factorysettings/" + newId);
      },
      inputVal:
        factoryorProductSettings.name +
        " (" +
        $langTextStore.getText("general-label-copy") +
        " )",
      actionButtonTextOverrideLangKey: "general-label-copy",
      cancelButtonTextOverrideLangKey: "general-label-cancel",
      titleLangKey: "general-copy-factory-setting-name",
      contentLangKey: "general-enter-name-for-new-version",
    });
  }
  function createProductFromFactorySetting() {
    push("/createproduct/" + params.factorySettingsId);
  }
  var x = $langTextStore.getText("general-label-copy");

  var fromProductId = null;
  $: setProductId($factoryStore.currentCalculator);

  function setProductId(factorySettings) {
    if (window.location.href.includes("fromproduct")) {
      fromProductId = window.location.href.split("fromproduct=")[1];
    }
  }
</script>

<div class="container-fluid" in:fade={{ duration: 1000 }}>
  {#if !hideCalc}
    <WizardCalculation bind:doCalculations />
    <div class="row thecalc navigator navigator--dark g-0 mb-0 mt-0">
      <div class="col-9">
        <Logo />
        {#if isProductMode}
          <h2 class="h2-border-left">
            {$langTextStore.getText("general-product-calculator")}
          </h2>
          <span
            on:click={() => {
              activeSection = "product";
              setTimeout(
                () => (currentSubSectionNameKey = "basic-settings"),
                40
              );
            }}
            class:active={activeSection == "product"}
            class="navigator__item  pt-4 c-pointer"
            >{$langTextStore.getText("general-header-product")}
          </span>

          {#if isLocked}
            <span
              on:click={() => {
                activeSection = "review-factory";
                setTimeout(
                  () => (currentSubSectionNameKey = "basic-settings"),
                  40
                );
              }}
              class:active={activeSection == "review-factory"}
              class="navigator__item  pt-4 c-pointer"
              >{$langTextStore.getText(
                "general-header-review-factory-settings"
              )}
            </span>
          {/if}
        {:else}
          <h2 class="h2-border-left">
            {$langTextStore.getText("general-factory-calculator")}
          </h2>
          <span
            on:click={() => {
              activeSection = "settings";
              setTimeout(
                () => (currentSubSectionNameKey = "basic-settings"),
                40
              );
            }}
            class:active={activeSection == "settings"}
            class="navigator__item  pt-4 c-pointer"
            >{$langTextStore.getText("general-header-factory-settings")}
          </span>
        {/if}
        <span
          on:click={() => {
            activeSection = "scenarios";
          }}
          class:active={activeSection == "scenarios"}
          class="navigator__item  pt-4 c-pointer"
        >
          {$langTextStore.getText("general-header-scenarios")}
        </span>
        {#if isProductMode}
          <span
            on:click={() => {
              activeSection = "breakdown";
            }}
            class:active={activeSection == "breakdown"}
            class="navigator__item  pt-4 c-pointer"
          >
            {$langTextStore.getText("general-header-reports")}
          </span>
        {:else}
          <span
            on:click={() => {
              activeSection = "productlist";
            }}
            class:active={activeSection == "productlist"}
            class="navigator__item  pt-4 c-pointer"
          >
            {$langTextStore.getText("general-header-products")}
          </span>
        {/if}
        <!-- <input
          name="workoffline"
          type="checkbox"
          bind:value={workOffline}
        /><label for="workoffline">Work offline</label> -->

        <span id="save-status">
          {#if savestatus == "saving"}
            <IconRecycle />
            {$langTextStore.getText("general-saving")} ..
          {:else if savestatus == "savedlocal"}
            <IconCloud />
            {$langTextStore.getText("general-saved-local")}
          {:else if savestatus == "saved"}
            <IconCloud />
            {$langTextStore.getText("general-saved-cloud")}
          {:else if savestatus == "savingtocloud"}
            <IconCloud />
            {$langTextStore.getText("general-saving-to-cloud")}
          {:else if savestatus == "dirty"}
            <IconCloud />
            {$langTextStore.getText("general-saved-not-saved-yet")}
          {:else}
            <IconCloud />
          {/if}
        </span>
      </div>
      <div class="col-3 text-right " style="white-space:nowrap">
        onlinemode:{$factoryStore.onlinemode}
        {#if savestatus == "savedlocal" && $factoryStore.onlinemode != "offline"}
          <button
            class="btn  px-4 py-3 mt-3 w-auto text-transform-upper"
            on:click={saveToCloud}
            >{$langTextStore.getText("general-save-to-cloud")}
          </button>
        {/if}
        <button
          class="btn btn-primary px-4 py-3 mt-3 w-auto text-transform-upper"
          on:click={cancel}
        >
          {#if fromProductId != null}
            {$langTextStore.getText("general-label-back-to-product")}
          {:else}
            {$langTextStore.getText("general-label-exit")}
          {/if}
        </button>
      </div>
    </div>
    <div class="row detail g-2">
      {#if activeSection == "settings" || activeSection == "review-factory" || activeSection == "product"}
        <div class="col-12 col-sm-6 col-lg-3 section vh-90">
          <div class="section__container h-100 pane">
            <h2 class="highlight">
              {#if isProductMode}
                {#if activeSection == "review-factory"}
                  {$langTextStore.getText("general-header-review-factory")}
                {:else}
                  {factoryorProductSettings.name}<br />
                  <span
                    >{factoryorProductSettings.brand}
                    {factoryorProductSettings.style}</span
                  >
                {/if}
              {:else}
                {$factoryStore.currentFactory.name}<br />
                <span>{factoryorProductSettings.name}</span>
              {/if}
              <!-- <span class="action-list">
                                {#if isProductMode}
                                    <IconCopy
                                        on:click={copyProduct}
                                        icontitle={$langTextStore.getText(
                                            "general-label-make-a-copy-product"
                                        )}
                                    />

                                    <IconDownload
                                        on:click={() => {
                                            alert("work in progress");
                                        }}
                                        icontitle={$langTextStore.getText(
                                            "general-label-download-product"
                                        )}
                                    />
                                {:else}
                                    <IconCopy
                                        on:click={copyFactory}
                                        icontitle={$langTextStore.getText(
                                            "general-label-factory-setting-copy"
                                        )}
                                    />

                                    <IconDownload
                                        on:click={() => {
                                            alert("work in progress");
                                        }}
                                        icontitle={$langTextStore.getText(
                                            "general-label-factory-setting-download"
                                        )}
                                    />
                                    <IconPlus
                                        on:click={createProductFromFactorySetting}
                                        icontitle={$langTextStore.getText(
                                            "general-label-factory-setting-make-product"
                                        )}
                                    />
                                {/if}
                            </span> -->
            </h2>

            <WizardSectionSelector
              isFactory={!isProductMode || activeSection == "review-factory"}
              bind:currentSubSectionNameKey
            />

            <div class="position-absolute bottom-0 pb-3 text-small prop-list">
              <!-- {#if isProductMode}
                               
                                {#if factoryorProductSettings.factorySettingId && factoryorProductSettings.factorySettingId.length > 0}
                                    <p class="prop-list__item">
                                        <span>Factory Setting</span><br />

                                        {#await factoryStore.getFactoryAndVersionName(factoryorProductSettings.factorySettingId) then factoryinfo}
                                            {factoryinfo}
                                            &nbsp;
                                            {#if !isLocked}
                                                <a
                                                    class="col-1"
                                                    id="logo"
                                                    title="View {factoryinfo}"
                                                    alt="View {factoryinfo}"
                                                    href="/calculator/factorysettings/{$factoryStore
                                                        .currentCalculator
                                                        .factorySettingId}?fromproduct={$factoryStore
                                                        .currentCalculator
                                                        .uuid}"
                                                    use:link><GoTo /></a
                                                >
                                            {/if}
                                        {/await}
                                    </p>
                                {/if}
                            {:else} -->
              <p class="mb-0 font-weight-bold">
                {#if hasPendingMajorUpgrade}
                  <span
                    class="text-primary ms-3 me-3 c-pointer"
                    title="Major update available!"
                    on:click={initiateMajorUpgrade}
                  >
                    <Pluscirkel />
                  </span>
                {/if}
              </p>
            </div>
          </div>
        </div>
        {#if activeSection != "breakdown" && activeSection != "scenarios"}
          <div class="col-12 col-sm-6  col-lg-3 section vh-90">
            <div class="section__container bg-gray-8 h-100 pane">
              <WizardInputSection
                readonly={isLocked}
                on:change={save}
                on:next={next}
                on:saveToCloud={saveToCloud}
                on:showWageDistribution={showWageDistribution}
                on:previous={previous}
                isFactory={!isProductMode || activeSection == "review-factory"}
                bind:currentSubSectionNameKey
              />

              {#if currentSubSectionNameKey && calculatorInputSections && factoryorProductSettings.subSections && factoryorProductSettings.subSections.length > 1}
                {#if !(currentSubSectionNameKey == calculatorInputSections[calculatorInputSections.length - 1].subSectionNameKey)}
                  <p class="mt-3 text-right">
                    <span class="link" on:click={next}
                      >{$langTextStore.getText(
                        "general-label-go-next-step"
                      )}</span
                    >
                  </p>
                {/if}
              {/if}
            </div>
          </div>
        {/if}
      {:else if activeSection == "scenarios"}
        <ScenarioTool
          on:change={() => {
            save();
          }}
        />
      {:else if activeSection == "productlist"}
        <ProductListForFactory
          factorySettingId={factoryorProductSettings.uuid}
        />
      {:else}
        <BreakDownSummary on:change={save} />
      {/if}
      {#if activeSection != "breakdown" && activeSection != "productlist"}
        <div
          class="col-12 {activeSection == 'scenarios'
            ? 'col-lg-7'
            : 'col-lg-6'} section vh-90 "
        >
          <div
            class="section__container pane h-100 {internalshowSuperHelp
              ? 'bg-primary'
              : ''}"
          >
            {#if internalShowSummary}
              <WizardSummarySection
                on:change={save}
                bind:activeSection
                isFactory={!isProductMode || activeSection == "review-factory"}
              />
            {/if}

            {#if internalshowSuperHelp}
              <WizardSuperHelpSection bind:showSuperHelp bind:activeSection />
            {/if}
          </div>
        </div>
      {/if}
    </div>
  {/if}
  {#if bShowWageDistribution}
    <Wagedistribution on:close={hideWageDistribution} on:change={save} />
  {/if}
  <div class="row mt-3 calc-version">
    <div class="col-12">
      <span>{$langTextStore.getText("general-label-calculator-version")}:</span>
      {$calculatorStore.country}
      {$calculatorStore.calculatorVersionNumber}
    </div>
  </div>
</div>
